import {useState} from 'react'
import PsiForm from './PsiForm';
import PsiListview from './PsiListview';

const PSI = () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");
  
    return (
      <>
        {fromIsShown ? (
          <PsiForm addForm={setFromIsShown} update={upData}  sId={serviceId}/>
        ) : (
          <PsiListview addForm={setFromIsShown} update={setUpData}  sId={setServiceId}/>
        )}
      </>
  )
}

export default PSI